var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTetherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.165 50C38.9722 50 50.165 38.8071 50.165 25C50.165 11.1929 38.9722 0 25.165 0C11.3579 0 0.165039 11.1929 0.165039 25C0.165039 38.8071 11.3579 50 25.165 50Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1682 27.161V27.1579C27.9963 27.1704 27.1103 27.2235 25.1338 27.2235C23.5557 27.2235 22.4447 27.1767 22.0541 27.1579V27.1626C15.9791 26.8954 11.4447 25.8376 11.4447 24.572C11.4447 23.3079 15.9791 22.2501 22.0541 21.9782V26.1095C22.451 26.1376 23.5885 26.2048 25.1603 26.2048C27.0463 26.2048 27.9916 26.1267 28.1682 26.111V21.9813C34.2307 22.2517 38.7541 23.3095 38.7541 24.572C38.7541 25.8376 34.2307 26.8923 28.1682 27.161ZM28.1682 21.5517V17.8548H36.6275V12.2173H13.5947V17.8548H22.0541V21.5501C15.1791 21.8657 10.0088 23.2282 10.0088 24.8595C10.0088 26.4907 15.1791 27.8517 22.0541 28.1688V40.0157H28.1682V28.1657C35.0322 27.8501 40.19 26.4892 40.19 24.8595C40.19 23.2298 35.0322 21.8688 28.1682 21.5517Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherIcon);
export default __webpack_public_path__ + "static/media/TetherIcon.73f8d54de0e63d0bf8695e1ffa59fbd1.svg";
export { ForwardRef as ReactComponent };